import { Controller as BaseController } from "@hotwired/stimulus";

export default class extends BaseController {
  static targets = [
    "name",
    "title",
    "visibilityStartInput",
    "visibilityEndInput",
    "eventStartInput",
    "eventEndInput",
    "visibilityEnd",
    "eventStart",
    "eventEnd",
    "detailsInput",
    "details",
    "toggleMore",
    "toggleLess",
  ];

  static values = {
    placeholderTitle: String,
    placeholderDate: String,
    placeholderDetails: String,
    expanded: { type: Boolean, default: false },
  };

  connect() {
    this.expandedValue = false;
    this.applyDetailsState();
    this.update();
  }

  update() {
    this.syncEventStartMinDate();

    if (this.hasTitleTarget && this.hasNameTarget) {
      const title = (this.nameTarget.value || "").trim();
      this.titleTarget.textContent =
        title || this.placeholderTitleValue || this.titleTarget.textContent;
    }

    if (this.hasVisibilityEndTarget && this.hasVisibilityEndInputTarget) {
      const visibilityEndAt = (this.visibilityEndInputTarget.value || "").trim();
      this.visibilityEndTarget.textContent =
        visibilityEndAt || this.placeholderDateValue || this.visibilityEndTarget.textContent;
    }

    if (this.hasEventStartTarget && this.hasEventStartInputTarget) {
      const eventStartAt = (this.eventStartInputTarget.value || "").trim();
      this.eventStartTarget.textContent =
        eventStartAt || this.placeholderDateValue || this.eventStartTarget.textContent;
    }

    if (this.hasEventEndTarget && this.hasEventEndInputTarget) {
      const eventEndAt = (this.eventEndInputTarget.value || "").trim();
      this.eventEndTarget.textContent =
        eventEndAt || this.placeholderDateValue || this.eventEndTarget.textContent;
    }

    if (this.hasDetailsTarget && this.hasDetailsInputTarget) {
      const details = (this.detailsInputTarget.value || "").trim();
      this.detailsTarget.textContent = details || this.placeholderDetailsValue || "";
    }

    if (this.hasDetailsTarget) {
      this.detailsTarget.classList.toggle("d-none", !this.expandedValue);
    }
  }

  syncEventStartMinDate() {
    if (!this.hasVisibilityStartInputTarget || !this.hasEventStartInputTarget) return;

    const visibilityDatepicker = $(this.visibilityStartInputTarget).data("datepicker");
    if (!visibilityDatepicker) return;

    const visibilityDate = $(this.visibilityStartInputTarget).datepicker("getDate");
    if (!visibilityDate) return;

    $(this.eventStartInputTarget).datepicker("setStartDate", visibilityDate);
    $(this.eventEndInputTarget).datepicker("setStartDate", visibilityDate);

    if (!this.eventStartInputTarget.value) {
      const datepickerEventStart = $(this.eventStartInputTarget).data("datepicker");
      if (datepickerEventStart) { datepickerEventStart.viewDate = visibilityDate; datepickerEventStart.fill(); }
    }

    if (!this.eventEndInputTarget.value) {
      const datepickerEventEnd = $(this.eventEndInputTarget).data("datepicker");
      if (datepickerEventEnd) { datepickerEventEnd.viewDate = visibilityDate; datepickerEventEnd.fill(); }
    }
  }

  toggleDetails() {
    this.expandedValue = !this.expandedValue;
    this.applyDetailsState();
  }

  applyDetailsState() {
    if (!this.hasDetailsTarget) return;

    this.detailsTarget.classList.toggle("d-none", !this.expandedValue);

    if (this.hasToggleMoreTarget) {
      this.toggleMoreTarget.classList.toggle("d-none", this.expandedValue);
    }

    if (this.hasToggleLessTarget) {
      this.toggleLessTarget.classList.toggle("d-none", !this.expandedValue);
    }
  }
}
